// CE-12084: a one-time incident notice shared across all accounts.
export const USAGE_INCIDENT_START = Date.parse('2026-05-20T00:00:00Z');
export const USAGE_INCIDENT_END = Date.parse('2026-05-21T00:00:00Z');
export const USAGE_INCIDENT_MESSAGE =
  'Usage data for May 20, 2026 (UTC) may be inaccurate due to a production incident.';

export const includesUsageIncident = (interval) =>
  interval?.[0]?.valueOf() < USAGE_INCIDENT_END && interval?.[1]?.valueOf() >= USAGE_INCIDENT_START;

// Use the normal axis tooltip so the notice also works over the filled series.
export const withUsageIncidentTooltip = (formatter, interval) => (params) => {
  const content = formatter(params);
  const point = Array.isArray(params) ? params[0] : params;
  const value = point?.axisValue ?? point?.value?.[0];
  const timestamp = typeof value === 'number' ? value : Date.parse(value);

  return includesUsageIncident(interval) &&
    timestamp >= USAGE_INCIDENT_START &&
    timestamp < USAGE_INCIDENT_END
    ? `${content}<br/>${USAGE_INCIDENT_MESSAGE}`
    : content;
};

export const usageIncidentMarkArea = (interval) => ({
  silent: true,
  itemStyle: { color: 'rgba(250, 173, 20, 0.18)' },
  label: { show: false },
  emphasis: { label: { show: false } },
  tooltip: { show: false },
  // Explicitly clear the annotation when navigating away from the incident.
  data: includesUsageIncident(interval)
    ? [
        [
          { name: USAGE_INCIDENT_MESSAGE, xAxis: USAGE_INCIDENT_START },
          { xAxis: USAGE_INCIDENT_END },
        ],
      ]
    : [],
});
